<script lang="ts" setup>
const { urlLangPart } = useLocales();

const ROOT_SITE_URL = import.meta.env.VITE_ROOT_SITE_URL;
</script>

<template>
  <a
    class="logo"
    :href="ROOT_SITE_URL + urlLangPart"
    target="_blank"
  >
    <img
      class="logo__img"
      src="@/assets/images/logo-main.svg"
      alt="veepn home"
      width="91"
      height="32"
    />
  </a>
</template>

<style lang="scss" scoped>
.logo {
  $this: 'logo';

  display: inline-block;
  line-height: 0;

  .#{$this}__img {
    @include media-down('md') {
      width: 70px;
      height: 25px;
    }
  }

  &__img {
    width: 91px;
    height: 32px;
  }
}
</style>
